import React, { useEffect, useRef, useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { FormErrorUI, InputUI } from '../Interface';
import dynamicFormService from '../../service/dynamicForm.service';

const AttendancePrefillEditor = ({ index, disabled }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const field = values.dynamicFormField?.[index];
  const template = field?.attendancePrefillTemplate ?? '';
  const inputRef = useRef(null);
  const [variables, setVariables] = useState([]);
  useEffect(() => {
    let active = true;
    dynamicFormService.getAttendancePrefillVariables().then((data) => {
      if (active) setVariables(data);
    }).catch(() => {});
    return () => { active = false; };
  }, []);
  const numeric = ['NUMBER', 'DECIMAL'].includes(field?.type);
  const date = field?.type === 'DATE';
  const availableVariables = variables.filter((variable) =>
    numeric ? variable.type === 'number' : date ? variable.type === 'date' : true);
  const update = (value) => setFieldValue(`dynamicFormField.${index}.attendancePrefillTemplate`, value);
  const insert = (token) => {
    if (numeric || date) {
      update(token);
      return;
    }
    const input = inputRef.current;
    const start = input?.selectionStart ?? template.length;
    const end = input?.selectionEnd ?? start;
    update(`${template.slice(0, start)}${token}${template.slice(end)}`);
    requestAnimationFrame(() => {
      input?.focus();
      input?.setSelectionRange(start + token.length, start + token.length);
    });
  };
  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>Előtöltés projektlejelentésből</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        A változókra kattintva összeállítható az előtöltés. Üresen nincs lejelentésből előtöltés.
        A projekt automatikusan átadásra kerül.
      </Typography>
      <InputUI
        inputRef={inputRef}
        label="Előtöltési sablon"
        value={template}
        onChange={(event) => update(event.target.value)}
        multiline={!numeric && !date}
        minRows={numeric || date ? undefined : 3}
        disabled={disabled}
        helperText={<FormErrorUI message={errors.dynamicFormField?.[index]?.attendancePrefillTemplate} />}
      />
      {(numeric || date) && (
        <Typography variant="caption">Egyetlen, a mező típusának megfelelő változó használható.</Typography>
      )}
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>Elérhető változók</Typography>
      <Box display="flex" flexWrap="wrap" gap={1}>
        {availableVariables.map((variable) => (
          <Chip
            key={variable.key}
            label={`${variable.label}: {{${variable.key}}}`}
            title={`Példa: ${variable.example}`}
            disabled={disabled}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => insert(`{{${variable.key}}}`)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AttendancePrefillEditor;
